import React, { useState } from 'react';
import {
  Box,
  CircularProgress,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  pdfContainer: {
    width: '100%',
    height: '600px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: 'none',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '600px',
    width: '100%',
  },
  errorContainer: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
}));

interface PDFViewerProps {
  pdfUrl: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ pdfUrl }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setError('Failed to load PDF. Please check if the file exists and is accessible.');
    setLoading(false);
  };

  return (
    <Paper className={classes.root}>
      <Typography variant="h6" gutterBottom>
      Original PDF Document
      </Typography>
      
      {loading && (
      <Box className={classes.loadingContainer}>
        <CircularProgress />
      </Box>
      )}
      
      {error ? (
      <Box className={classes.errorContainer}>
        <Typography variant="body1" color="error">
        {error}
        </Typography>
      </Box>
      ) : (
      <iframe
        src={`${pdfUrl}#toolbar=1&navpanes=1&view=FitH`}
        className={classes.pdfContainer}
        onLoad={handleLoad}
        onError={handleError}
        style={{ display: loading ? 'none' : 'block' }}
        title="PDF Viewer"
      />
      )}
    </Paper>
  );
};

export default PDFViewer;
